var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCexMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.132324 10C0.132324 4.47715 4.60948 0 10.1323 0C15.6552 0 20.1323 4.47715 20.1323 10C20.1323 15.5228 15.6552 20 10.1323 20C4.60948 20 0.132324 15.5228 0.132324 10Z",
    fill: "#C4C4C4"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCexMock);
export default __webpack_public_path__ + "static/media/cexMock.5ec513595679b6f13b7ce889ff3fb1eb.svg";
export { ForwardRef as ReactComponent };